/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询某条评论信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetProductCommentParams {
  constructor(public commentId?: string) {}
}

export default async function (
  params: GetProductCommentParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.ProductCommentDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/comment`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
